import React, { useState, useEffect } from 'react';
import * as S from './styles';
import api from '../../services/api';
import { notifyApiError } from '../../services/apiError';
import { Loading } from '../loading';
import { theme } from '../../styles/theme';

const GraphicOverviewMetric = ({ dtInicial, dtFinal, ...props }) => {
    const [qtdArt, setQtdArt] = useState(null);
    const [qtdArtAnterior, setQtdArtAnterior] = useState(null);
    const [trendPercent, setTrendPercent] = useState(null);

    const searchInitialData = async () => {
        setQtdArt(null);
        setTrendPercent(null);

        try {
            const response = await api.get('/relatorio/metrica-art-trt', {
                params: { dtInicial, dtFinal },
            });

            setQtdArt(response.data.data.total);
            setQtdArtAnterior(response.data.data.totalAnterior);
            setTrendPercent(response.data.data.percentage ?? null);
        } catch (error) {
            notifyApiError(error, 'Falha ao carregar número de ART/TRT emitidas.');
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [dtInicial, dtFinal])

    const hasTrend = trendPercent !== null;
    const isPositive = hasTrend && trendPercent >= 0;
    const isNew = !hasTrend && qtdArt > 0;

    // Progresso do círculo: quanto do total do período anterior já foi atingido
    // neste novo período (limitado a 100%). Sem período anterior como meta,
    // considera 100% se já emitiu algo, ou 0% se ainda não emitiu nada.
    const ringPercent = qtdArtAnterior > 0
        ? Math.min(100, Math.round((qtdArt / qtdArtAnterior) * 100))
        : (qtdArt > 0 ? 100 : 0);

    return (
        <S.Container>
            {qtdArt !== null ? (
                <S.Ring percent={ringPercent}>
                    <div className="inner">{qtdArt}</div>
                </S.Ring>
            ) : (
                <S.LoadingBox>
                    <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
                </S.LoadingBox>
            )}

            <S.Content>
                <S.Title>Número de ART/TRT cadastradas</S.Title>

                {hasTrend ? (
                    <S.Trend positive={isPositive}>
                        <span className="arrow">{isPositive ? '▲' : '▼'}</span>
                        <span className="percent">{isPositive ? '+' : ''}{trendPercent}%</span>
                        <span className="label">vs. período anterior</span>
                    </S.Trend>
                ) : isNew && (
                    <S.Trend positive>
                        <span className="percent">Novo</span>
                    </S.Trend>
                )}
            </S.Content>
        </S.Container>
    )
}

export default GraphicOverviewMetric;
